module.exports = __webpack_public_path__ + "static/media/Asset1.6b48fec1.png";